import _ from 'lodash'

import {
  FETCHING_USER,
  FETCHED_USER,
  NO_LOGGED_USER,
  EDIT_USER_DATA,
  SAVING_USER_DATA,
  ERROR_SAVING_USER_DATA,
} from '_reducers/auth'
import { MydAPI } from '_services/default'
import { deserializeUserData } from '_actions/users'


export function editUserData(data) {
  return {
    type: EDIT_USER_DATA,
    data,
  }
}

function _errorSavingData(data) {
  return {
    type: ERROR_SAVING_USER_DATA,
    data,
  }
}

function _savingUserData() {
  return {
    type: SAVING_USER_DATA,
  }
}

function _fetchingUser() {
  return {
    type: FETCHING_USER,
  }
}

function _noLoggedUser() {
  return {
    type: NO_LOGGED_USER,
  }
}

function _fetchedUser(user) {
  return {
    type: FETCHED_USER,
    user,
  }
}

export const updateUserData = (data) => {
  return dispatch => new Promise((resolve, reject) => {

    let links = {}

    _.each(data.links, (url, key) => {
      if ( ! _.isEmpty(url))
        links[key] = url
    })

    dispatch(_savingUserData())

    data = {
      attributes: {
        links,
        first_name: data.firstName,
        last_name: data.lastName,
        description: data.description,
        country: data.location.country,
        region: data.location.region,
        url: data.url,
      },
      id: _.toString(data.id),
      type: 'user',
    }

    MydAPI.patch('/users/me', {data}).then(response => {

      if (response.status === 200) {
        let retData = response.data.data,
            retUser = deserializeUserData(retData)

        dispatch(_fetchedUser(retUser))
        resolve(retUser)
      } else {
        dispatch(_noLoggedUser())
        resolve({})
      }

    }).catch(err => {
      dispatch(_errorSavingData())
      reject(err)
    })
  })
}

export const updateUserImage = (userId, url, type='avatar') => {
  return dispatch => new Promise((resolve, reject) => {
    dispatch(_savingUserData())

    let data = {
      attributes: {
        [type]: url,
      },
      id: _.toString(userId),
      type: 'user',
    }

    MydAPI.patch('/users/me', {data}).then(response => {

      if (response.status === 200) {
        let retData = response.data.data,
            retUser = deserializeUserData(retData)

        dispatch(_fetchedUser(retUser))
        resolve(retUser)
      } else {
        dispatch(_noLoggedUser())
        resolve({})
      }

    }).catch(err => {
      reject(err)
    })
  })
}

export const fetchUser = _.memoize(() => {
  return dispatch => new Promise((resolve, reject) => {

    dispatch(_fetchingUser())

    MydAPI.get('/users/me').then(response => {

      if (response.status === 200) {
        let retData = response.data.data,
            retUser = deserializeUserData(retData)

        dispatch(_fetchedUser(retUser))
        resolve(retUser)
      } else {
        dispatch(_noLoggedUser())
        resolve({})
      }

    }).catch(err => {
      reject(err)
    })
  })
})

export const fetchUserMenu = _.memoize(menuType => {
  return new Promise((resolve, reject) => {

    MydAPI.get(`/assets/menu/${menuType}?page[size]=0`).then(response => {
      let menus = _.map(response.data.data, menu => {
        return {
            id: menu.id,
            ...menu.attributes,
          }
      })

      resolve(menus)

    }).catch(err => {
      reject(err)
    })
  })
})
